import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Chapter, EASE, MaskedLines, Reveal } from "@/components/aklive/motion";
import { PlaceholderBlock } from "@/components/aklive/PlaceholderBlock";

const MOMENTS = [
  { name: "Launching", service: "Brand Identity & Website", outcome: "Be recognised. Be understood.", label: "[BRAND SYSTEM — 3:2]" },
  { name: "Raising", service: "Pitch Deck", outcome: "Make the opportunity clear.", label: "[PITCH DECK SPREAD — 3:2]" },
  { name: "Selling", service: "Packaging", outcome: "Shape perception.", label: "[PACKAGING CLOSE-UP — 3:2]" },
  { name: "Scaling", service: "Content Systems", outcome: "Stay consistent.", label: "[CONTENT SYSTEM — 3:2]" },
  { name: "Hosting", service: "Events", outcome: "Create an experience.", label: "[EVENT PHOTO — 3:2]" },
];

export const Moments = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-24 md:py-40" data-testid="moments-section">
      <div className="container-ak">
        <Chapter index="05" label="Business Moments" />
        <h2 className="mb-14 font-display text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl md:mb-20">
          <MaskedLines lines={["What are you", <span key="l2">building next<span className="text-ember">?</span></span>]} />
        </h2>

        <Reveal className="border-t border-line">
          {MOMENTS.map((m, i) => {
            const isOpen = open === i;
            return (
              <div key={m.name} className="border-b border-line">
                <button
                  type="button"
                  data-testid={`moment-${m.name.toLowerCase()}-btn`}
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="group flex w-full items-baseline justify-between py-6 text-left md:py-8"
                >
                  <span className="flex items-baseline gap-5 md:gap-8">
                    <span className="font-mono text-[10px] tracking-[0.2em] text-ink2">0{i + 1}</span>
                    <span
                      className={`font-display text-3xl font-bold tracking-tight transition-colors duration-300 sm:text-4xl md:text-5xl ${
                        isOpen ? "text-ember" : "text-ink group-hover:text-ember"
                      }`}
                    >
                      {m.name}
                    </span>
                  </span>
                  <span
                    aria-hidden="true"
                    className={`text-xl text-ink2 transition-transform duration-300 md:text-2xl ${isOpen ? "rotate-45" : ""}`}
                  >
                    +
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="panel"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: EASE }}
                      className="overflow-hidden"
                    >
                      <div className="grid gap-8 pb-10 pl-0 md:grid-cols-2 md:pl-16">
                        <div>
                          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink2">Relevant service</p>
                          <p className="mt-3 font-display text-xl font-bold uppercase tracking-tight text-ink md:text-2xl">
                            {m.service}
                          </p>
                          <p className="mt-2 text-base text-ember md:text-lg">{m.outcome}</p>
                        </div>
                        <PlaceholderBlock label={m.label} ratio="3 / 2" className="md:max-w-md md:justify-self-end" />
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </Reveal>
      </div>
    </section>
  );
};
